module.exports = __webpack_public_path__ + "img/ry_19.b3210e5f.png";